import { useEffect } from "react";

import { ExtensionMessageType } from "@punto/frontend-shared/extension";

import { sendBridgeMessage } from "@/lib/extension/bridge-client";
import { useUserOrganizations } from "@/modules/auth/hooks/use-user-organizations";

/**
 * Syncs the current Auth0 organization to the Chrome extension on app load
 * and whenever the org changes. The extension's sidebar uses Auth0 React SDK
 * for auth, but needs this signal to know when to re-authenticate with a
 * different org (since Auth0 SDK caches tokens locally).
 */
export const ExtensionOrgSync = () => {
  const { currentOrganization } = useUserOrganizations();
  const orgId = currentOrganization?.referenceId;

  useEffect(() => {
    if (!orgId) return;
    sendBridgeMessage(ExtensionMessageType.SYNC_ORGANIZATION, {
      organizationId: orgId,
    });
  }, [orgId]);

  return null;
};
